import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const Field = ({ label, hint, children, optional }) => (
  <div className="space-y-2">
    <Label className="text-sm font-bold">
      {label} {optional && <span className="text-muted-foreground font-medium">(optional)</span>}
    </Label>
    {children}
    {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
  </div>
);

export const PickSelect = ({ value, onChange, options, placeholder, testId }) => (
  <Select value={value || undefined} onValueChange={onChange}>
    <SelectTrigger className="h-12 rounded-xl" data-testid={testId}>
      <SelectValue placeholder={placeholder || "Select..."} />
    </SelectTrigger>
    <SelectContent className="max-h-72">
      {options.map((o) => {
        const v = typeof o === "string" ? o : o.value;
        const l = typeof o === "string" ? o : o.label;
        return <SelectItem key={v} value={v}>{l}</SelectItem>;
      })}
    </SelectContent>
  </Select>
);

export const StepHeader = ({ title, text }) => (
  <div className="mb-8">
    <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">{title}</h2>
    {text && <p className="mt-2 text-muted-foreground">{text}</p>}
  </div>
);
